import { useSyncExternalStore } from 'react';

const subscribe: (onStoreChange: () => void) => () => void = () => (): void => {};
const getSnapshot: () => boolean = () => true;
const getServerSnapshot: () => boolean = () => false;

/**
 * `true` once the component has hydrated on the client; `false` during SSR and
 * the first (hydration) render. The canonical replacement for the
 * `useState(false)` + `useEffect(() => setMounted(true), [])` mount guard — it
 * reads from `useSyncExternalStore` so there is no synchronous `setState`
 * inside an effect (no wasted pre-paint render), and hydration still matches
 * the server because `getServerSnapshot` returns `false`.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
